import { LEGAL_TERMS_OF_USE_HEADING } from './0-heading.md';
import { LEGAL_TERMS_OF_USE_INTRODUCTION } from './1-introduction.md';
import { LEGAL_CONTRACTUAL_INFORMATION } from './2-contractual-information.md';
import { LEGAL_PAYMENT_TERMS } from './3-payment-terms.md';
import { LEGAL_PRICE_AND_TAX_CHANGES } from './4-price-and-tax-changes.md';
import { LEGAL_USAGE_GUIDELINES_AND_LIMITATIONS } from './5-usage-guidelines-limitations.md';
import { LEGAL_PRODUCT_SERVICE_SPECIFICS } from './6-product-service-specifics.md';
import { LEGAL_TERMS_OF_USE_CANCELLATION_POLICIES } from './7-cancellation-policies.md';
import { LEGAL_WARRANTY } from './9-warranty.md';
import { LEGAL_TERMS_OF_USE_REFUND_POLICY } from './8-refund-policy.md';
import { LEGAL_USER_ENGAGEMENT } from './11-user-engagement.md';
import { LEGAL_MARKETING_AND_NEWSLETTER } from './12-marketing-newsletter.md';
import { LEGAL_PRIVACY_STATEMENT } from './13-privacy-statement.md';
import { LEGAL_INTELLECTUAL_PROPERTY_RIGHTS } from './14-intellectual-property-rights.md';
import { LEGAL_LIMITATION_OF_LIABILITY } from './15-limitation-of-liability.md';
import { LEGAL_GOVERNING_LAW } from './16-governing-law.md';
import { LEGAL_CHANGES_TO_TERMS } from './17-changes-to-terms.md';
import { LEGAL_TERMINATION } from './18-termination.md';
import { LEGAL_SEVERABILITY } from './19-severability.md';
import { LEGAL_ASSIGNMENT } from './20-assignment.md';
import { LEGAL_AI_TOKEN_SYSTEM } from './10-ai-token-system.md';


/**------------------------------------------------------
 * Imprint Template
 */
export const LEGAL_TERMS_OF_USE_TEMPLATE_EN: string = `
	<!-- let sectionIndex = 0; subSectionIndex = 0; -->
	${LEGAL_TERMS_OF_USE_HEADING}
	${LEGAL_TERMS_OF_USE_INTRODUCTION}
	---
	${LEGAL_CONTRACTUAL_INFORMATION}
	---
	${LEGAL_PAYMENT_TERMS}
	---
	${LEGAL_PRICE_AND_TAX_CHANGES}
	---
	${LEGAL_USAGE_GUIDELINES_AND_LIMITATIONS}
	---
	<!-- if (termsOfUse.productTerms.length > 0) { -->
	${LEGAL_PRODUCT_SERVICE_SPECIFICS}
	---
	<!-- } -->
	${LEGAL_TERMS_OF_USE_CANCELLATION_POLICIES}
	---
	${LEGAL_TERMS_OF_USE_REFUND_POLICY}
	---
	<!-- if (termsOfUse.products.freeVersionSAAS || termsOfUse.products.subscriptionSAAS) { -->
	${LEGAL_WARRANTY}
	---
	<!-- } -->
	<!-- if (termsOfUse.products.aiTokenSystem) { -->
	${LEGAL_AI_TOKEN_SYSTEM}
	---
	<!-- } -->
	${LEGAL_USER_ENGAGEMENT}
	---
	${LEGAL_MARKETING_AND_NEWSLETTER}
	---
	${LEGAL_PRIVACY_STATEMENT}
	---
	${LEGAL_INTELLECTUAL_PROPERTY_RIGHTS}
	---
	${LEGAL_LIMITATION_OF_LIABILITY}
	---
	${LEGAL_GOVERNING_LAW}
	---
	${LEGAL_CHANGES_TO_TERMS}
	---
	${LEGAL_TERMINATION}
	---
	${LEGAL_SEVERABILITY}
	---
	${LEGAL_ASSIGNMENT}
`;
